import React, { useEffect, useRef, useState } from 'react';
import { useImageControls } from './common/useImageControls';
import { ImageControls } from './common/ImageControls';
import { Recovery } from './common/Recovery';
import { FileExclamationOutlined } from '@ant-design/icons';
import { ViewerPropertiesComplete } from '../model';
export const MediaImageVector: React.FC<ViewerPropertiesComplete> = ({
  src,
  attachEventsToDocument,
}) => {
  const [svg, setSVG] = useState<null | string>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [errorState, setErrorState] = useState<'ok' | 'error' | 'recovering'>('recovering');

  const imageController = useImageControls(
    errorState === 'ok',
    containerRef,
    attachEventsToDocument,
  );

  useEffect(() => {
    setErrorState('recovering');
  }, [src]);

  useEffect(() => {
    const controller = new AbortController();
    const f = async () => {
      const r = await fetch(src, { signal: controller.signal });
      if (r.ok) {
        const body = await r.text();
        setSVG(() => body);
        setErrorState('ok');
      } else {
        setErrorState('error');
      }
    };

    if (errorState === 'recovering') {
      void f();
    }

    return () => {
      controller.abort();
    };
  }, [src, setErrorState, errorState]);

  const body =
    errorState === 'ok' ? (
      <>
        <div
          dangerouslySetInnerHTML={{ __html: svg ?? '' }}
          onMouseDown={imageController.dragOnMouseDown}
          style={{
            transform: imageController.cssTransform,
          }}
        />
        <ImageControls controller={imageController} />
      </>
    ) : errorState === 'error' ? (
      <>
        <div style={{ fontSize: 80 }}>
          <FileExclamationOutlined />
        </div>
        <Recovery onRecovery={() => setErrorState('recovering')} />
      </>
    ) : (
      <progress max="100" />
    );
  return (
    <div className="gen-file-viewer__image-container gen-file-viewer__container" ref={containerRef}>
      {body}
    </div>
  );
};
